import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {UtilService} from "../../services/util.service";
import {NavigationEnd, Router} from "@angular/router";
import {DataService} from "../../services/data.service";
import {MatDialog} from "@angular/material/dialog";
import {PriceHistoryDetailDialogComponent} from "../../components/dialog/price-history-detail-dialog/price-history-detail-dialog.component";
import {FormControl, Validators} from "@angular/forms";

@Component({
  selector: 'app-request-history',
  templateUrl: './request-history.component.html',
  styleUrls: ['./request-history.component.scss']
})
export class RequestHistoryComponent implements OnInit, OnDestroy {

  market = 'ALL';
  customDealsRequestHistory: any[];
  customDealsRequestHistoryTable: any[] = [];

  loading = false;
  isRequestHistoryPage;
  tabIndex: number = 0;

  searchValue;
  dropDownSelection = new FormControl('opportunityName', [Validators.required]);
  dropDownOptions: object[] = [{label: "Opportunity Name", value: "opportunityName"}, {label: "Quote Number", value: "quoteId"}, {label: "Legal Entity Name", value: "legalEntityName"}];
  displayedColumns: any[] = [];
  requestHistoryRows;
  @ViewChild('requestHistoryTable') requestTable;
  @ViewChild('contractHistoryTable') contractTable;

  constructor(public utilService: UtilService, private router: Router, public dataService: DataService, public dialog: MatDialog) {
    router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        this.isRequestHistoryPage = val.urlAfterRedirects == '/rfp-history';
      }
      this.tabIndex = !this.isRequestHistoryPage ? 1: 0;
    })
  }

  ngOnInit(): void {
    if(this.isRequestHistoryPage) {
      this.displayedColumns = [
        {field: 'market', label: 'Market'},
        {field: 'opportunityName', label: 'Opportunity Name'},
        {field: 'legalEntityName', label: 'Legal Entity Name'},
        {field: 'dueDate', label: 'Due Date', type: 'date'},
        {field: 'billingAddressLin1', label: 'Address'},
        {field: 'billingAddressCity', label: 'City'},
        {field: 'billingAddressState', label: 'State'},
        {field: 'billingAddressZip', label: 'Zip'},
        {field: 'duns', label: 'DUNS'},
        {field: 'requestDatetime', label: 'Request Date', type: 'date'}
      ]
      // this.displayedColumns = ['market', 'opportunityName', 'legalEntityName', 'dueDate', 'billingAddressLin1', 'billingAddressCity', 'billingAddressState', 'billingAddressZip', 'duns', 'requestDatetime'];
    }else {
      this.displayedColumns = [
        {field: 'market', label: 'Market'},
        {field: 'opportunityName', label: 'Opportunity Name'},
        {field: 'legalEntityName', label: 'Legal Entity Name'},
        {field: 'quoteId', label: 'Quote Number'},
        {field: 'federalTaxId', label: 'Federal Tax Id'},
        {field: 'startDate', label: 'Start Date', type: 'date'},
        {field: 'term', label: 'Terms'},
        {field: 'contractTemplateName', label: 'Contract Template Name'},
        {field: 'created', label: 'Request Date', type: 'date'}
        ]
      // this.displayedColumns = ['market', 'opportunityName', 'legalEntityName', 'quoteId', 'federalTaxId', 'startDate', 'term', 'contractTemplateName', 'created'];
    }
      this.getHistoryData();
  }

  onTabChange(e){
    if(e == 1){
      this.router.navigate(['/contract-history']);
    }else{
      this.router.navigate(['/rfp-history']);
    }
  }

  async restGetData() {
    this.loading = true;
    if(this.isRequestHistoryPage) {
      await this.dataService.restCustomDealsRequestHistory().then((data: any) => {
        this.loading = false;
        this.getHistoryData()
      }).catch((error) => {
        this.loading = false;
      })
    }else{

      await this.dataService.restCustomDealsContractHistory().then((data: any) => {
        this.loading = false;
        // this.customDealsRequestHistory = data;
        // this.customDealsRequestHistoryTable = data;
        this.getHistoryData()
      }).catch((error) => {
        this.loading = false;
      })
    }
  }

  getHistoryData() {
    let data: any;
    let self = this;
    if(self.isRequestHistoryPage)
      data = self.dataService.getCustomDealsRequestHistory();
    else
      data = self.dataService.getCustomDealsContractHistory();
    if (!data) {
      self.restGetData();
      return;
    }
    self.customDealsRequestHistory = data;
    self.customDealsRequestHistoryTable = data;
    // this.requestHistoryRows = new MatTableDataSource(data as RequestHistoryClass[]);
    // this.requestHistoryRows.paginator = this.paginator;
    // this.requestHistoryRows.sort = this.sort;
    self.requestHistoryRows = data;
    setTimeout(() => {
      if(self.isRequestHistoryPage)
        self.requestTable.initializeTable(data);
      else
        self.contractTable.initializeTable(data);
    }, 100, data)

  }

  openPriceDetail(row) {

    const dialogRef = this.dialog.open(PriceHistoryDetailDialogComponent
      , {
        data: {
          priceDetail: row
        }
        , panelClass: 'contract-generator-dialog'
      }
    );
    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }


  ngOnDestroy(): any {

  }

  search(val): any {
    // if(this.isRequestHistoryPage) {
    //   this.customDealsRequestHistoryTable = this.customDealsRequestHistory.filter(row => {
    //       return row.opportunityName && row.opportunityName.toLowerCase().includes(this.searchText.toLowerCase());
    //     }
    //   );
    // }else{
    //   this.customDealsRequestHistoryTable = this.customDealsRequestHistory.filter(row => {
    //       return !val || row[this.dropDownSelection.value] && row[this.dropDownSelection.value].toString().toLowerCase().includes(val.toLowerCase());
    //     }
    //   );
    // }
    if(this.isRequestHistoryPage)
      this.requestTable.search(val);
    else
      this.contractTable.search(val);
  }

  getDropdownLabel(){
    let selectedVal: any = this.dropDownOptions.filter((item: any) => item.value === this.dropDownSelection.value)
    return selectedVal[0] ? "Search by " + selectedVal[0].label + "   ..." : "Search by ......"
  }

  dropDownSelectionChange(){
    this.searchValue = "";
    // this.search()
  }


}
